import React from "react";
import { Box } from "@mui/material";
import styles from "./styles";
import DocumentWithFace from "../../assets/svg/DocumentWithFace";

function DataNotFoundMessage() {
  return (
    <Box style={styles.container}>
      <DocumentWithFace />
      <Box style={styles.text}>No Data Found!</Box>
    </Box>
  );
}

export default DataNotFoundMessage;
